export class SectionChartIndex {
    sectionId: number;
    chartIndex: number;

    constructor(sectionId: number, chartIndex: number) {
        this.sectionId = sectionId;
        this.chartIndex = chartIndex;
    }
}
